export const alfiUserId = window.localStorage.getItem('alfiUserId');
export const alfiUserEmail = window.localStorage.getItem('alfiUserEmail');
export const ALFI_USER_ID = 'alfiUserId';
export const ALFI_USER_EMAIL = 'alfiUserEmail';
export const secretKey = '92671491-871d-4eee-8487-bf2007395d4f';
